import React from 'react';
import useClientPortalService, { BrandingDto, UpdateBrandingRequest } from '../Domain/clientPortalService';
import { useDataLoaderNew } from 'data-loader';
import LoadingAnimation from '../../../shared/LoadingAnimation';
import ClientPortalBrandingForm, { BrandingFormData } from './ClientPortalBrandingForm';

export default function ClientPortalBrandingSection() {
  const service = useClientPortalService();
  const { data: branding, refreshData } = useDataLoaderNew(service.getBranding);

  const handleSubmit = async (formData: BrandingFormData) => {
    try {
      // Build the update request - always include theme
      const request: UpdateBrandingRequest = {
        logoFileId: formData.logoFileId,
        theme: formData.theme,
      };

      const result = await service.updateBranding(request);

      // Refresh data from server to get latest state
      refreshData();

      // Convert result back to form data format
      return mapBrandingToFormData(result);
    } catch (error) {
      console.error('Failed to update branding configuration:', error);
      throw error;
    }
  };

  const mapBrandingToFormData = (dto: BrandingDto): BrandingFormData => {
    // Default colors if backend doesn't return a theme
    const defaultTheme = {
      fontColor1: '#426377',
      fontColor2: '#FFFFFF',
      detailBoxHighlightColor1: '#4cd964',
      detailBoxHighlightColor2: '#4cd964',
      detailBoxShadingColor1: '#dde7eb4d',
      detailBoxShadingColor2: '#eefcf0',
    };

    return {
      logoFileId: dto.logoFileId,
      _logoUrl: dto._logoUrl, // Pass the logo URL structure for preview
      theme: dto.theme || defaultTheme, // Use backend theme or defaults
    };
  };

  if (!branding) {
    return <LoadingAnimation />;
  }

  const formData = mapBrandingToFormData(branding);

  return <ClientPortalBrandingForm initialData={formData} onSubmit={handleSubmit} />;
}
